import * as otpActions from "../actionTypes/otpActionTypes"

export interface OtpState {
  referenceId: string;
  isValid: boolean;
  attemptsLeft: number;
  otpError: any;
}

const initialState: OtpState = {
  referenceId: "",
  isValid: false,
  attemptsLeft: -1,
  otpError: false,
}

export const OtpReducer = (
  state: OtpState = initialState,
  action: otpActions.OtpActions
): OtpState => {
  switch (action.type) {
    case otpActions.GENERATE_OTP_SUCCESS:
      return {
        ...state,
        referenceId: action.response.referenceId
      };
      case otpActions.GENERATE_OTP_FAILURE:
        return {
          ...state,
          otpError: true
        };
      
    case otpActions.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        isValid: action.response.isValid,
        attemptsLeft: action.response.attemptsLeft
      }
    case otpActions.VERIFY_OTP_FAILURE:
      return {
        ...state,
        otpError: true
      };
    default:
      return state
  }
}